import { resolvePolymorphVar } from "@green24/npm-javascript-utils";

export class StateHandlerV2 {
	constructor({initialState, defaultInitialState}) {
		this.state = null;
		this.initialState = resolvePolymorphVar(
			initialState,
			{
				function: f => f(defaultInitialState),
				object: o => ({
					...defaultInitialState,
					...o,
				})
			},
			() => initialState,
			true
		);
	}

	/**
	 * @abstract
	 * Setup actions
	 * ---
	 */
	setupActions() {
		return {};
	}
}
